module.exports = {
  ROUTES: [
    {
      ID: 'report',
      WIDGET_LABEL: 'special report',
      WIDGET_TITLE: 'Check out our China Internet Report 2019',
      WIDGET_FOOTER_TITLE: 'China Internet Report 2019',
      WIDGET_SERVE_PATH: 'china-internet-report',
      WIDGET_PATH: 'https://www.scmp.com/china-internet-report',
      WIDGET_IMAGE: '/static/images/image_cir.png',
      TARGET_DOMAIN: 'https://multimedia.scmp.com/',
      TARGET_PATH: '2018/graphics/china-internet',
      NEW_WINDOW: true,
    },
    {
      ID: 'report-2018',
      WIDGET_LABEL: 'special report',
      WIDGET_TITLE: 'Check out our China Internet Report 2018',
      WIDGET_FOOTER_TITLE: 'China Internet Report 2018',
      WIDGET_SERVE_PATH: 'china-internet-report-2018',
      WIDGET_PATH: '/china-internet-report-2018',
      WIDGET_IMAGE: '/static/images/image_cir.png',
      TARGET_DOMAIN: 'https://multimedia.scmp.com/',
      TARGET_PATH: '2018/graphics/china-internet',
      NEW_WINDOW: false,
    },
  ],
  REDIRECT: [
    {
      FROM: '/report',
      TO: 'https://www.scmp.com/china-internet-report',
    },
    {
      FROM: '/china-internet-report',
      TO: 'https://www.scmp.com/china-internet-report',
    },
  ],
}



// WEBPACK FOOTER //
// ./config/china-internet-report.js